"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function inViewport(elem, offset, strict) {
    var bounding = elem.getBoundingClientRect();
    var padding = offset || 0;
    var contained = !!strict;
    return strict
        ? bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= window.innerHeight && bounding.right <= window.innerWidth
        : (bounding.top >= offset && bounding.top <= window.innerHeight - offset) ||
            (bounding.bottom >= offset && bounding.bottom <= window.innerHeight - offset);
}
exports.inViewport = inViewport;
